<template>
  <div class="author">
        <div class="info">
            <img class="avatar" src="../assets/Avatar.jpg" >
            <h2>雪谋</h2>
            <h5>YukiHakarigoto</h5>
            <h4></h4>
        </div>
        <b-container fluid class="p-4">
            <b-row>
                <b-col>
                    <a rel="noopener" target="_blank" @click="dribbble" href="https://dribbble.com/YukiHakarigoto">
                        <img class="social" src="../assets/Dribbble.png">
                    </a>
                </b-col>
                <b-col>
                    <a rel="noopener" target="_blank" @click="zcool" href="https://www.zcool.com.cn/u/15527038">
                        <img class="social" src="../assets/ZCOOL.png">
                    </a>
                </b-col>
                <b-col>
                    <a rel="noopener" target="_blank" @click="twitter" href="https://twitter.com/YukiHakarigoto">
                        <img class="social" src="../assets/Twitter.png">
                    </a>
                </b-col>
                <b-col>
                    <a rel="noopener" target="_blank" @click="weibo" href="https://weibo.com/u/6193090141">
                        <img class="social" src="../assets/Weibo.png">
                    </a>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
    methods: {
        dribbble() {
            this.$ga.event('social', 'visit', 'dribbble', 1)
            },
        zcool() {
            this.$ga.event('social', 'visit', 'zcool', 1)
            },
        twitter() {
            this.$ga.event('social', 'visit', 'twitter', 1)
            },
        weibo() {
            this.$ga.event('social', 'visit', 'weibo', 1)
            },
        },
}
</script>

<style lang="stylus" scoped>
h5
    color #999999
.author
    text-align: center;
.info
    display flex
    flex-direction column
    justify-content center
    align-items center
    padding 50px 0px
.avatar
    width 220px
    border-radius 50%
    padding-bottom: 20px
.social
    width 200px
    padding-bottom: 20px
</style>